import { Segment, Table, Header } from 'semantic-ui-react';

type PayDownNoticeStatusProps = {
    paydownPlanStatusReponse?: PayDownPlanQuotesStatusResponse;
  }

export default function PayDownNoticeStatus({ paydownPlanStatusReponse }: PayDownNoticeStatusProps) {
    return (
        <Segment>
            <Header as="h2">Notice status {paydownPlanStatusReponse?.noticePeriod?.firstBillingPeriodId ?? "(n/a)"} - {<span>{paydownPlanStatusReponse?.noticePeriod?.lastBillingPeriodId ?? "(n/a)"}</span>}</Header>
        </Segment>
    );
}